import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { percentageFilter } from "app/filters/ngFilters";

import { Column } from "../../../common/legend/Column";
import { DomainColumn } from "../../../common/legend/DomainColumn";
import type { ILegendColumnConfig } from "../../../common/legend/MetricLegend";
import { MetricLegend } from "../../../common/legend/MetricLegend";

interface IShareMetricLegendProps {
    dataAutomation: string;
    shareDataAutomation: string;
}

export const ShareMetricLegend = ({ dataAutomation, shareDataAutomation }: IShareMetricLegendProps) => {
    const { translate } = useTranslate();

    const columns = useMemo(
        (): ILegendColumnConfig[] => [
            {
                header: translate("activation.alerts.metrics.legend.domain"),
                textAlign: "left",
                render: (item) => (
                    <DomainColumn
                        key="domain"
                        item={item}
                    />
                ),
            },
            {
                header: translate("activation.alerts.metrics.legend.share"),
                render: (item) => (
                    <Column
                        key="share"
                        fontVariant={item.isMaxValue ? "subtitle2" : "body2"}
                        data-automation={shareDataAutomation}
                    >
                        {`${percentageFilter()(item.y, 0)}%`}
                    </Column>
                ),
            },
        ],
        [translate, shareDataAutomation],
    );

    return (
        <MetricLegend
            columns={columns}
            dataAutomation={dataAutomation}
        />
    );
};
